import React, { useState } from 'react';
import { Field, useFormikContext } from 'formik';

import {
  InputUI,
  FormErrorUI,
  FormLabelUI,
  AutoCompleteSelectUI,
  CheckboxUI,
  ButtonUI,
  ConfirmDialogUI,
} from '../Interface';
import BinDialog from './BinDialog';

export const WarehouseFields = ({ viewField, addField, selectedValuesState, autocompleteOptions, updateWhs }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  const { selectedValues } = selectedValuesState;

  const [confirmDialogState, setConfirmDialogState] = useState({
    show: false,
    handleChangeElement: () => {
      setFieldValue('binManaged', true);
      setFieldValue('binLevel', 1);
      setConfirmDialogState((prevState) => ({ ...prevState, show: false }));
    },
    onHide: () => {
      setConfirmDialogState((prevState) => ({ ...prevState, show: false }));
    },
    message: 'A rakhelyes készletkezelés beállítása nem vonható vissza. Folytatja?',
  });

  const [binDialogState, setBinDialogState] = useState({
    open: false,
    selectedValuesState,
    onClose: () => {
      setBinDialogState((prev) => ({ ...prev, open: false }));
    },
    updateWhs: updateWhs,
  });

  return (
    <>
      <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
        <div className="md:col-span-2 col-span-4">
          <Field
            type="text"
            name="code"
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Raktárkód" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.code} />}
            disabled={viewField || addField}
            InputLabelProps={{ shrink: values.code && values.code !== '' }}
          />
        </div>
        <div className="md:col-span-2 col-span-4">
          <Field
            type="text"
            name="name"
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Raktár neve" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.name} />}
            disabled={viewField}
            InputLabelProps={{ shrink: values.name && values.name !== '' }}
          />
        </div>
        <div className="md:col-span-2 col-span-4">
          <Field
            type="autocomplete"
            name="companyLocationId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Telephely" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.companyLocationId} />}
            onChange={(_e, newVal) => {
              setFieldValue('companyLocationId', newVal?.value ?? null).then(() => {
                validateField('companyLocationId');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.companyLocationId !== '' }}
            selectedValue={values.companyLocationId}
            selectedLabelValue={selectedValues?.companyLocation?.name}
            dataset={autocompleteOptions?.companyLocation}
          />
        </div>
      </div>
      {/* 
        binManaged 
        binLevel
        binSeparator
        */}
      <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
        <div className="md:col-span-1 col-span-4">
          <Field
            name="binManaged"
            component={CheckboxUI}
            checked={values.binManaged ?? false}
            variant="standard"
            onChange={(e) => {
              const value = e.target.checked;
              if (value) {
                setConfirmDialogState((prevState) => ({
                  ...prevState,
                  show: true,
                }));
                return;
              }
              setFieldValue('binLevel', null);
              setFieldValue('binManaged', false);
              setFieldValue('binSeparator', '');
            }}
            disabled={viewField || selectedValues?.binManaged}
            fullWidth
            label={<FormLabelUI text="Rakhelyes készletkezelés" />}
          />
        </div>
        {values.binManaged && (
          <div className="md:col-span-1 col-span-4 flex items-center justify-center">
            <ButtonUI
              text="Rakhelyek"
              size="sm"
              className="bg-labelColor py-3"
              onClick={() => setBinDialogState((prev) => ({ ...prev, open: true, selectedValuesState }))}
              disabled={viewField}
            />
          </div>
        )}
      </div>
      <ConfirmDialogUI {...confirmDialogState} />
      <BinDialog {...binDialogState} />
    </>
  );
};
